import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
import _imports_0 from '@/assets/icons/actions/ico-ico-delete-gray.svg';
const _hoisted_1 = { class: "d-flex justify-content-start" };
const _hoisted_2 = {
    key: 0,
    class: "side-box__content__label"
};
const _hoisted_3 = { class: "d-flex align-items-center" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "side-box__row d-flex align-items-center" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormInput = _resolveComponent("FormInput");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.hideTitle)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t("USER_ATTRIBUTES")), 1))
            : _createCommentVNode("", true),
        _createElementVNode("div", {
            class: _normalizeClass(["d-flex", {
                    'flex-column': !_ctx.displayInRow,
                    'flex-wrap align-items-center': _ctx.displayInRow
                }]),
            style: { "gap": "15px" }
        }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from({ length: _ctx.visibleAttributes.length }, (v, i) => i), (index) => {
                return (_openBlock(), _createElementBlock("div", null, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["side-box__row d-flex align-items-center justify-content-end", { 'ml-3': !_ctx.displayInRow }]),
                        style: { "gap": "15px" }
                    }, [
                        _createVNode(_component_FormInput, {
                            label: index === 0 || _ctx.displayInRow ? _ctx.$t('TITLE') : '',
                            value: _ctx.visibleAttributes[index]?.title,
                            onChange: ($event) => (_ctx.userAttributes = _ctx.userAttributes.map((attr) => attr.id === _ctx.visibleAttributes[index]?.id ? { ..._ctx.visibleAttributes[index], title: $event } : attr))
                        }, null, 8, ["label", "value", "onChange"]),
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_FormInput, {
                                class: "mr-2",
                                label: index === 0 || _ctx.displayInRow ? _ctx.$t('VALUE') : '',
                                value: _ctx.visibleAttributes[index]?.value,
                                onChange: ($event) => (_ctx.userAttributes = _ctx.userAttributes.map((attr) => attr.id === _ctx.visibleAttributes[index]?.id ? { ..._ctx.visibleAttributes[index], value: $event } : attr))
                            }, null, 8, ["label", "value", "onChange"]),
                            _createElementVNode("div", {
                                class: _normalizeClass([index === 0 || _ctx.displayInRow ? 'mt-4' : 'mt-1', "pointer"]),
                                onClick: ($event) => (_ctx.deleteAttribute(index))
                            }, _cache[1] || (_cache[1] = [
                                _createElementVNode("img", {
                                    class: "",
                                    src: _imports_0
                                }, null, -1)
                            ]), 10, _hoisted_4)
                        ])
                    ], 2)
                ]));
            }), 256)),
            _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                    class: _normalizeClass({ 'ml-3 mb-2': !_ctx.displayInRow, 'mt-4': _ctx.displayInRow })
                }, [
                    _createElementVNode("a", {
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.addUserAttribute()))
                    }, _toDisplayString(_ctx.$t("ADD_ATTRIBUTE")), 1)
                ], 2)
            ])
        ], 2)
    ]));
}
